import { MapPin, Car, Trees, BedDouble } from "lucide-react";
import Packages from "../../src/Images/Tours.jpg";
import CabsImage from "../../src/Images/services.jpg";
import RetreatsImage from "../../src/Images/Retreats.JPG";
import StaysImage from "../../src/Images/Stays.jpeg";

import { Link } from "react-router-dom";

export default function App() {
  const offers = [
    {
      id: "tours",
      title: "Adventure Awaits",
      subtitle: "Tour Packages",
      description:
        "Discover hidden gems and iconic spots with our all-inclusive tour packages. Your perfect getaway starts here!",
      image: Packages,
      color: "from-orange-500 to-red-500",
      icon: <MapPin className="h-6 w-6" />,
      route: "/packages",
    },
    {
      id: "retreats",
      title: "Reconnect & Recharge",
      subtitle: "Retreats",
      description:
        "Explore wellness and leisure retreats designed for rest, renewal, and memorable escapes.",
      image: RetreatsImage,
      color: "from-green-500 to-emerald-500",
      icon: <Trees className="h-6 w-6" />,
      route: "/wellness",
    },
    {
      id: "cabs",
      title: "Ride Your Way",
      subtitle: "Cabs",
      description:
        "Choose shared or private cab options for smooth, comfortable, and convenient travel.",
      image: CabsImage,
      color: "from-blue-500 to-cyan-500",
      icon: <Car className="h-6 w-6" />,
      route: "/bookCabs",
    },
    {
      id: "stays",
      title: "Stay in Comfort",
      subtitle: "Stays",
      description:
        "Find curated stays and accommodations that match your travel style and comfort.",
      image: StaysImage,
      color: "from-purple-500 to-pink-500",
      icon: <BedDouble className="h-6 w-6" />,
      route: "/hotels",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-r from-white via-slate-25 to-white">
      <section className="py-16 px-4 md:px-6 lg:px-8 border-b">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-blue-900 mb-10">
              Our Services
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {offers.map((offer) => (
              <Link
                key={offer.id}
                to={offer.route}
                className="relative overflow-hidden rounded-2xl group block h-[260px] md:h-[280px]"
              >
                <img
                  src={offer.image}
                  alt={offer.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-6 flex flex-col justify-end">
                  <div
                    className={`inline-block p-2 rounded-lg bg-gradient-to-br ${offer.color} text-white w-fit mb-2`}
                  >
                    {offer.icon}
                  </div>
                  <h3 className="text-white text-xl font-semibold mb-1">
                    {offer.subtitle}
                  </h3>
                  <p className="text-white/80 text-sm line-clamp-2">
                    {offer.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}